import { render, staticRenderFns } from "./SpaceEditor.vue?vue&type=template&id=ebc8e306&scoped=true"
import script from "./SpaceEditor.vue?vue&type=script&lang=js"
export * from "./SpaceEditor.vue?vue&type=script&lang=js"
import style0 from "./SpaceEditor.vue?vue&type=style&index=0&id=ebc8e306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc8e306",
  null
  
)

export default component.exports